module.exports = __webpack_public_path__ + "media/images/worktype_role/tecnicos-4cb84f38beabc965784090539335b73b.png";